<style scoped lang="scss">
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/craft/document/issued/log/page" getKey="rows"
        :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="false" :type="'equipment'" :ids.sync="yt.conditions.equipmentIds"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('peifang')">
            <el-input v-model="yt.conditions.mouldNo"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{$t('sousuo')}}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc' })">{{$t('chongzhi')}}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #buttonsL>
      </template>
      <template #buttonsR>
      </template>

      <!-- 操作插槽 -->
      <template #caozuo="scope">

      </template>
      <!-- 底部插槽 -->
      <template #footer>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
        :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body>
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('kehubianma')" required>
            <el-input v-model="yt.editObj.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('kehumingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('kehudizhi')" required>
            <el-input v-model="yt.editObj.address"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lianxiren')">
            <el-input v-model="yt.editObj.contacts"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lianxifangshi')">
            <el-input v-model="yt.editObj.contactsInfo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('youxiang')">
            <el-input v-model="yt.editObj.email"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST','/web/wms/customer/create')"
              type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
      </template>


      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('kehubianma')" required>
            <el-input v-model="yt.editObj.code" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('kehumingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('kehudizhi')" required>
            <el-input v-model="yt.editObj.address"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lianxiren')">
            <el-input v-model="yt.editObj.contacts"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lianxifangshi')">
            <el-input v-model="yt.editObj.contactsInfo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('youxiang')">
            <el-input v-model="yt.editObj.email"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST','/web/wms/customer/update')"
              type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
      </template>

    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_process_distribution_forming_document_issued_log',
  components: {},
  data() {
    return {
      show: false,
      exportExcelLoading: false,
      routerEquipmentIds: null,
      columns: [{
        label: 'xiafazhuangtai',
        prop: 'status',
        type: 'dictionary',
        key: 'CRAFT_DOCUMENT_ISSUED_LOG_STATUS',
        width: 150,
      },
        {
          label: 'yueshutiaojian',
          prop: 'constraints',
          type: 'dictionary',
          key: 'YSTJ',
          width: 150
        },
        {
          label: 'xiafashebeisn',
          prop: 'equipment.sn'
        },
        {
          label: 'xiafashebeimingcheng',
          prop: 'equipment.name',
        },
        {
          label: 'xiafapeifang',
          prop: 'mouldNo',
        },
        {
          label: 'xiafashijian',
          prop: 'issuedTime',
          type: 'time',
          width: 150
        },
        {
          label: 'xiafaren',
          prop: 'createByObject.nickname',
        },

      ],
    };

  },

  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'createTime desc',
        equipmentIds: this.routerEquipmentIds
      };
      this.yt.get(1);
    }, 300)

  },
  activated() {
  },
  mounted() {
    this.routerEquipmentIds = this.$route.query.equipmentId;

    // 如果有传递参数，更新条件的 equipmentIds
    if (this.routerEquipmentIds) {
      // 更新选中值
      setTimeout(() => {
        this.$set(this.yt.conditions, "equipmentIds", Number(this.routerEquipmentIds));
      }, 300)
    }
  },
  methods: {

  },
};
</script>
